import { mdiWheelchairAccessibility } from '@mdi/js';
import Icon from '@mdi/react';
import clsx from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';
import { Store } from '../../../types/Store';
import useWizardContext from '../../../hooks/useWizardContext';
import classes from '../classes.module.css';

const StoreTileNoTimeslot: React.FC<{
  store: Store;
}> = ({ store }) => {
  const intl = useIntl();
  const ctx = useWizardContext();
  const { id } = ctx.appointmentType || {};

  return (
    <div className={classes.boxWrapper}>
      <div className={classes.box}>
        <a className={classes.openButtonMobilenoparticip} href={store.ctaUrl}>
          link na store
        </a>
        <div className={classes.left}>
          <div>
            <h3 style={{ margin: '0px' }}>{store.name}</h3>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35em', marginTop: '0.35em' }}>
            <span>{store.street}</span>
            <span>{store.city}</span>
            <span>{store.postalCode}</span>
          </div>
          {!store.isWheelChairAccessible && (
            <div className={classes.badge}>
              <span>
                <Icon path={mdiWheelchairAccessibility} size='18px' />{' '}
                {intl.formatMessage({ id: 'store.accessibility' })}
              </span>
            </div>
          )}
        </div>
        <div className={clsx(classes.right, classes.rightNoparticipating)}>
          <div className={classes.timeslotInfo}>
            <span className={classes.noParticipatingMsg}>
              {intl.formatMessage({ id: 'appointmentTypeSelection.' + id + '.noTimeslot' })}
            </span>
          </div>
          <a className={classes.noparticipBtn} href='/afspraak-maken'>
            {intl.formatMessage({ id: 'store.select.contactFormButton' })}
          </a>
        </div>
      </div>
    </div>
  );
};

StoreTileNoTimeslot.displayName = 'StoreTileNoTimeslot';

export default StoreTileNoTimeslot;
